module.exports = __webpack_public_path__ + "img/marker-green.bc6fdd6b.svg";